import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./App.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Mixpanel } from "./mixpanel";
import { getTimestamp } from './components/timeStamp.js'

import { userAtom, advisorAtom } from './atom.js'
import { useRecoilState } from 'recoil'
import { recordHmrcMfaAtLogin } from './services/hmrcGovHeaders.js'



import {
    IonAlert,
} from '@ionic/react';


// import { useToasts } from 'react-toast-notifications'

// function withToast(Component) {
//     return function WrappedComponent(props) {
//         const toastFuncs = useToasts()
//         return <Component {...props} {...toastFuncs} />;
//     }
// }


const AgentLogin = (props) => {

    // recoil state
    const [, setUser] = useRecoilState(userAtom)
    const [, setAdvisor] = useRecoilState(advisorAtom)
    // const [tax_years_atom, setTaxYearsAtom] = useRecoilState(taxYearsAtom)
    // end of recoil state
    const [pageLoaded, setPageLoaded] = useState(false)
    const [initial, setInitial] = useState(false)
 
    const [username, setUsername] = useState("")

//    const [newPassword, setNewPassword] = useState("")
//    const [confirmPassword, setConfirmPassword] = useState("")

    const [secretcode, setSecretcode] = useState("")

    const [headingText, ] = useState("Personal taxes, untied")
    const [error, setError] = useState({
        show: false,
        errorTitle: "",
        errorSubTitle: "",
        errorText: ""
    })
    const [qrCode, setQRCode] = useState("");
    const [mfaCode, updateMFACode] = useState("");
    const [doMFA, setDoMFA] = useState(false)
    const [mfaSecret, setMFASecret] = useState("")

    useEffect(()=>{
        if(!initial){
            setUser({})
            setAdvisor({})
            setInitial(true)
        }
    },[initial, setAdvisor, setUser, setInitial])

    useEffect(() => {
        if (pageLoaded) { 
            localStorage.setItem("pingTime", new Date())           
            props.history.push('/clients')            
        }
    }, [pageLoaded, props])

    const updateUsername = (event) => {
        setUsername(event.target.value)
    };

    const updateSecretcode = (event) => {
        setSecretcode(event.target.value)
    }

    const validateEmail = (email) => {
        // eslint-disable-next-line
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const auth = (email, token, usePassword = true, mfa_code="") => {

        

        if (!validateEmail(email)){
            setError({
                errorTitle: "Invalid Email",
                errorSubTitle: "",
                errorText: "Please make sure email is in correct format"
            })
            return;
        }

        var body = JSON.stringify({ email, token, mfa_code });
        if (usePassword) {
            body = JSON.stringify({ email, password: token, mfa_code });
        }
        // props.agentAuth(email, token, usePassword)
        

        fetch(`https://${global.api_url}/agent/agentLogin.php?ts=${getTimestamp()}`, {
            method: "POST",
            body: body,
            headers: { partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
        })
        // .then(res => res.text())
        // .then(t => {
            
          
        //     
            .then(res => res.json())
            .then(json => {            
   
                if (json.status === "success") {

                    if (json.mfa==="Y" && mfa_code==="") {

                        //did we get a qr code back ... 
                        setDoMFA(true)
                        setQRCode(json.mfa_qr)
                        setMFASecret(json.mfa_secret)

                    } else {

                        let agent_user = {
                            agentToken: json.token,
                            agent: json.id,
                            name: json.name,
                            logged_in: true,
                            username: json.email,
                            users: [...json.users],
                            secret: secretcode,
                            user_email_required: json.user_email_required || 'Y',
                            require_acceptance: json.require_acceptance || 'Y'
                        }
                        let clients = [...json.users]
                        let clientString = JSON.stringify(clients)
                        localStorage.setItem('logged_in', true)
                        localStorage.setItem('agent', json.id)
                        localStorage.setItem("agentToken", json.token)
                        localStorage.setItem("agent_username", json.email);
                        localStorage.setItem("users", clientString)
                        localStorage.setItem("agent_code", json.agent_code)
                        localStorage.setItem("arn", json.arn)
                        localStorage.setItem("agent_name", json.name)
                        localStorage.setItem("user_email_required", json.user_email_required || 'Y')
                        localStorage.setItem("require_acceptance", json.require_acceptance || 'Y')
                        localStorage.setItem("email_template", json.email_template)
                        localStorage.setItem("mtd", json.mtd)
                        // localStorage.setItem("secret", secretcode)
                        // setUser(agent_user)
                        setAdvisor(agent_user)
                        recordHmrcMfaAtLogin(json.id);

                        Mixpanel.track(`${json.email}_agent_log_in`);
                        
                        setPageLoaded(true)

                    }
                } else {

                    // if (!usePassword) {
                    //     auth(email, token, true);
                    //     return;
                    // }

                    if (mfa_code==="") {

                        setError({
                            show: true,
                            errorTitle: "Unauthorised",
                            errorSubTitle: "",
                            errorText: "There was a problem logging you in, please check you have entered the correct email and secret code or password."
                        })
                    } else {
                        setError({
                            show: true,
                            errorTitle: "Unauthorised",
                            errorSubTitle: "",
                            errorText: "There was a problem logging you in, please check you have entered a valid multi-factor authentication code."
                        })
                    }



                    Mixpanel.track("Unsuccessful login");
                }
            });
    }

    
    const handleKeyDownSecret = (e) => {
        if (e.key === 'Enter') {
            auth(username, secretcode, true)
        }
    }

    const handleKeyDownMFACode = (e) => {
        if (e.key === 'Enter') {
            auth(username, secretcode, true, mfaCode)
        }
    }

    // const changePassword = () => {

    //     const body = JSON.stringify({ email: username, password: secretcode, newPassword: newPassword, confirmPassword: confirmPassword });


    //     fetch(`https://${global.api_url}/agent/changePassword.php?ts=${getTimestamp()}`, {
    //         method: "POST",
    //         body: body,
    //         headers: { partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
    //     })
    //         .then(res => res.json())
    //         .then(json => {
    //             // 
    //             if (json.status === "success") {
    //                 alert("password changed ... ");
    //                 // setShowUserList(false)
    //                 setUsername("")
    //                 setSecretcode("")
    //                 setChangingPassword(false)
    //             } else {
    //                 alert(json.info)
    //             }
    //         });

    // }


  

    const doBottomView = () => {

        
        if (doMFA) {
            return (
                
                <div>
                {qrCode!=="" && (
                    <>
                        <p style={{ color: 'white' }}>Please use the Google Authenticator app to scan this QR code and enable MFA:</p>

                        <img alt="Authenticator QR Code" src={qrCode} />

                        <p style={{ color: 'white' }}>Alternatively enter this secret which you can also store securely as a backup:</p>

                        <textarea value={mfaSecret}/>
                    </>
                )}

            
                <p style={{ color: 'white' }}>Please enter authentication code:</p>

                <TextField
                    autoFocus
                    style={styles.input}
                    onKeyPress={handleKeyDownMFACode}
                    autoCapitalize="none"
                    value={mfaCode}
                    onChange={event => updateMFACode(event.target.value)}
                    type="password"
                    placeholder="Code"
                    margin="none"
                    InputProps={{ disableUnderline: true }}
                />


                <div
                    style={{
                        flexDirection: "row",
                        flex: 1,
                        paddingBottom: 10,
                        paddingLeft: 10,
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                />

                <Button
                    style={styles.buttonContainer}
                    size="small"
                    onClick={() => auth(username, secretcode, true, mfaCode)}
                >
                    Login
                </Button>


                </div>

            )
        }




        return (
            <div>

                <p style={{ color: 'white' }}>Enter your adviser login</p>

                <TextField
                    autoFocus
                    style={styles.input}
                    autoCapitalize="none"
                    value={username}
                    onChange={event => updateUsername(event)}
                    placeholder="Email address"
                    margin="none"
                    InputProps={{ disableUnderline: true }}
                />

                <div style={{ paddingTop: 5 }} />

                <TextField

                    style={styles.input}
                    onKeyPress={handleKeyDownSecret}
                    autoCapitalize="none"
                    value={secretcode}
                    onChange={event => updateSecretcode(event)}
                    type="password"
                    placeholder="Password"
                    margin="none"
                    InputProps={{ disableUnderline: true }}
                />

                <div
                    style={{
                        flexDirection: "row",
                        flex: 1,
                        paddingBottom: 10,
                        paddingLeft: 10,
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                />

                <Button
                    style={styles.buttonContainer}
                    size="small"
                    onClick={() => auth(username, secretcode, true)}
                >
                    Login
          </Button>

          <p style={{ color: 'white' }}>Forgotten your password? <a href="https://www.untied.io/contact-team-untied/" style={{color:'white'}}>Contact us</a>.</p>


            </div>
        );

    }

    const scale = (val) => {
        return val;
    }

    const styles = {
        root: {
            background: "black"
        },
        card: {
            minWidth: 675
        },
        bullet: {
            display: "inline-block",
            margin: "0 2px",
            transform: "scale(0.8)"
        },
        title: {
            fontSize: 14
        },
        pos: {
            marginBottom: 12
        },
        buttonContainer: {
            paddingVertical: 12,
            width: "100%",
            marginBottom: 15,
            height: 36,
            borderRadius: 4,
            backgroundColor: "#c7ff00",
            color: "#0C90B2",
            textTransform: "none",
            fontSize: 14,
            fontWeight: 700
        },
        buttonContainer2: {
            paddingVertical: 12,
            width: "100%",
            marginBottom: 15,
            height: 36,
            borderRadius: 4,
            color: "#ffffff",
            textTransform: "none",
            fontSize: 14,
            fontWeight: 700,
            borderColor: "#FFFFFF",
            borderStyle: "solid",
            borderWidth: scale(1)
        },
        buttonText: {
            color: "#0C90B2",
            textAlign: "center",
            fontWeight: "700"
        },
        input: {
            width: "95%",
            //height: scale(48),
            borderRadius: scale(4),
            borderColor: "#ffffff",
            borderStyle: "solid",
            borderWidth: scale(1),
            backgroundColor: "#84C8D9",
            color: "#ffffff",
            paddingLeft: 16,
            placeholderTextColor: "#ffffff",
            textAlign: "center",
            fontSize: scale(14),
            marginLeft: 0
            //marginRight: 16
        },
        passInput: {
            color: "#ffffff",
            paddingLeft: 16,
            placeholderTextColor: "#ffffff",
            fontSize: scale(14),
        },
        itIs: {
            color: "#c7ff00",
            fontSize: 18,
            fontWeight: "500",
            letterSpacing: 0.54,
            textAlign: "center",
            alignSelf: "center"
        }
    }


    return (
        <div
            style={{
                backgroundColor: "#FAFAFC",
                width: "100%",
                height: "100vh",
                //height:"100%",
                paddingTop: 30,
                overflow:'auto'
            }}
        >

            <div
                style={{ display: "flex", justifyContent: "center", marginTop: 50 }}
            >
                <Card
                    style={{ backgroundColor: "#0c90b2", width: 400, borderRadius: 5 }}
                >
                    <CardContent>
                        <div
                            style={{
                                marginTop: 20,
                                marginBottom: 20,
                                flex: 0.6,
                                justifyContent: "center",
                                textAlign: "center"
                            }}
                        >
                            <img
                                style={{
                                    width: "100%",
                                    paddingLeft: -40,
                                    paddingTop: 20
                                }}
                                alt=""
                                src={require("./images/untied-white-logo.png").default}
                            />
                        </div>
                        <p
                            style={{
                                fontSize: 18,
                                color: "#ffffff",
                                paddingBottom: 30,
                                textAlign: "center",
                                justifyContent: "center",
                                alignItems: "center",
                                textTransform: "none",
                                fontWeight: 700
                            }}
                        >
                            {headingText}
                        </p>
                        {doBottomView()}
                    </CardContent>
                </Card>
            </div>


            <IonAlert
                isOpen={error.show}
                onDidDismiss={() => setError({
                    show: false,
                    errorTitle: "",
                    errorSubTitle: "",
                    errorText: ""
                })}
                header={error.errorTitle}
                subHeader={error.errorSubTitle}
                message={error.errorText}
                buttons={['OK']}
            />
        </div>

    );



    // end of functional component
}

export default withRouter(AgentLogin)